import { Modal } from 'reactstrap';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  height: fit-content;
  max-width: 600px;
  max-height: 304px;
  top: 5%;
  gap: 24px;
`;
